<template>
<div>
    <!-- Modal confirm delete account -->
    <modal name="modal-confirm-delete-account">
        <div class="text-lg font-bold text-red-700">
            <i class="mr-2 fas fa-exclamation-triangle"></i> {{$t('parametres.mon_compte.vous_etes_sur_le_point_de_supprimer_votre_compte_ainsi_que_toutes_les_informations_liees_a_celui_ci')}}
            <div class="pt-6 mt-2 mt-6 text-sm border-t">
                {{$t('parametres.mon_compte.souhaitez_vous_reellement_continuer')}}
            </div>
        </div>

        <div class="flex mt-4">
            <button @click="$modal.hide('modal-confirm-delete-account')" class="px-3 py-2 mr-2 text-sm font-light text-gray-700 duration-200 bg-gray-200 border-gray-200 rounded hover:bg-gray-300">
                <i class="mr-1 fas fa-times"></i> {{$t('parametres.mon_compte.annuler')}}
            </button>
            <button @click="deleteAccount" class="px-3 py-2 text-sm font-light text-white duration-200 bg-red-500 border-red-500 rounded hover:bg-red-600" test-id="btn-delete-account">
                <i class="mr-1 fas fa-check"></i> {{$t('parametres.mon_compte.confirmer')}}
            </button>
        </div>
    </modal>

    <update-card v-if="user" :user="user" :label="$t('parametres.mon_compte.adresse_email')" keyname="mail" input-type="email" />
    <div class="p-6 my-4 bg-white border border-gray-200 my-rounded">
        <div v-if="!passwordIsOpen" class="flex items-center justify-between">
            <div>
                <div class="text-lg font-bold">{{$t('parametres.mon_compte.mot_de_passe')}}</div>
            </div>
            <button @click="passwordIsOpen = true" test-id="btn-open-update-password" class="px-3 py-2 text-sm font-light text-gray-700 duration-200 bg-gray-200 border-gray-200 rounded hover:bg-gray-300"> {{$t('parametres.mon_compte.modifier')}} </button>
        </div>
        <div v-if="passwordIsOpen">
            <h1 class="pb-3 mb-3 text-xl font-bold border-b">{{$t('parametres.mon_compte.nouveau_mot_de_passe')}}</h1>
            <sav-input-password v-model="password" />
            <div class="mt-2">
                <button @click="passwordIsOpen = false; password = null" class="px-3 py-2 text-sm font-light text-gray-700 duration-200 bg-gray-200 border-gray-200 rounded hover:bg-gray-300"> {{$t('parametres.mon_compte.annuler')}} </button>
                <button @click="updatePassword" test-id="btn-submit-new-password" class="px-3 py-2 text-sm font-light duration-200 bg-green-300 border-green-300 rounded hover:bg-green-400"> {{$t('parametres.mon_compte.modifier')}} </button>
            </div>
        </div>
    </div>
    <div class="p-6 my-4 bg-white border border-gray-200 my-rounded">
        <div class="flex items-center justify-between">
            <div>
                <div class="text-lg font-bold">{{$t('parametres.mon_compte.deconnexion')}}</div>
            </div>
            <button @click="$router.push({name: 'user.logout'})" test-id="btn-logout" class="px-3 py-2 text-sm font-light text-gray-700 duration-200 bg-gray-200 border-gray-200 rounded hover:bg-gray-300"> {{$t('parametres.mon_compte.se_deconnecter')}} </button>
        </div>
    </div>
    <div class="p-6 bg-white border border-gray-200 mt-28 my-rounded">
        <div class="flex items-center justify-between">
            <div>
                <div class="text-lg font-bold">{{$t('parametres.mon_compte.supprimer_mon_compte')}}</div>
            </div>
            <button @click="$modal.show('modal-confirm-delete-account')" test-id="btn-modal-delete-account" class="px-3 py-2 text-sm font-light text-gray-700 duration-200 bg-red-200 border-red-200 rounded hover:bg-red-300"> {{$t('parametres.mon_compte.supprimer')}} </button>
        </div>
    </div>
</div>
</template>

<script>
import apiService from '@/services/api.service'
import sha256 from 'js-sha256';

import UpdateCard from './../components/UpdateCard.vue'
import SavInputPassword from '@/components/SavInputPassword'
export default {
    components: {UpdateCard, SavInputPassword},
    props: {
        user: {
            required: true
        }
    },
    data() {
        return {
            passwordIsOpen: false,
            loading: false,
            password: null,
        }
    },

    methods: {
        async updatePassword() {
            if (this.password.valid) {
                this.loading = true

                if (this.password.valid) {
                    let objData = {
                        prenom: this.user.prenom,
                        nom: this.user.nom,
                        mail: this.user.mail,
                        tel: this.user.tel,
                        id_conso: this.user.id,
                        password: sha256(this.password.password)
                    }

                    let response = await apiService.post('setconso', objData)
                    this.$toast.success(this.$t('parametres.mon_compte.mot_de_passe_modifie'))
                }

                this.password = null
                this.passwordIsOpen = false
                this.loading = false
            }
        },

        async deleteAccount()
        {
            await apiService.post('delete_user', {
                id_conso: this.$crypto.decrypt(localStorage.getItem('client_id'))
            })
            this.$router.push({name: 'user.logout'})
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/companies/default/views/user/settings/AccountSettingsSection.vue